import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React from "react";

export const IconMenuSearch = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path d="M13.1498 11.6918H12.3819L12.1098 11.4294C13.0623 10.3213 13.6358 8.88279 13.6358 7.3179C13.6358 3.82847 10.8073 1 7.3179 1C3.82847 1 1 3.82847 1 7.3179C1 10.8073 3.82847 13.6358 7.3179 13.6358C8.88279 13.6358 10.3213 13.0623 11.4294 12.1098L11.6918 12.3819V13.1498L16.5517 18L18 16.5517L13.1498 11.6918ZM7.3179 11.6918C4.89766 11.6918 2.94397 9.73814 2.94397 7.3179C2.94397 4.89766 4.89766 2.94397 7.3179 2.94397C9.73814 2.94397 11.6918 4.89766 11.6918 7.3179C11.6918 9.73814 9.73814 11.6918 7.3179 11.6918Z" fill="#AEB4BE" />
        </SvgIcon>
    );
};